import styled from 'styled-components';
import { PriceLabel } from '../price-label';
import { layout } from 'src/components/base';
import { Badge } from '@prisjakt/ui/badge';

export const PRICE_LABEL_SIZE = '16px';
const PRICE_LABEL_LINE_HEIGHT = '24px';

export const StyledPriceLabel = styled(PriceLabel)`
  font-size: ${PRICE_LABEL_SIZE};
  line-height: ${PRICE_LABEL_LINE_HEIGHT};
  text-align: right;
  margin-bottom: 0;
`;

export const StyledSecondaryPrice = styled(PriceLabel)`
  text-decoration: line-through;
  line-height: ${PRICE_LABEL_LINE_HEIGHT};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  column-gap: ${layout.measurements.spacing050};
`;

export const PriceAndShipping = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  column-gap: ${layout.measurements.spacing050};
`;

export const StyledBadge = styled(Badge)`
  > span {
    font-weight: 400;
    font-size: 0.85em;
  }
`;
